import { useState } from 'react'
import styled from 'styled-components'
import { MAX_PER_PAGE } from '../../../constants/other'

import {
  SettingsTableHead,
  SettingsTableBody,
  Empty,
  NothingFound,
} from './tableComponents'
import Table from '../../myTable/MyTable'

const TableStyle = styled.div<{ hasdata: string }>`
  width: 100%;

  /* height: 600px; */
  /* min-height: 500px; */
  //overflow:scroll;

  ${({ hasdata }) =>
    hasdata === 'true' && 'border: 1px solid var(--border-main, #ededed);'}

  table {
    /* height: 100%; */
    /* table-layout: fixed; */
    width: 100%;
    border: none;
    border-collapse: collapse;

    td {
      border: none;

      vertical-align: middle;
      /* height: fit-content; */

      p {
        text-align: center;
        vertical-align: middle;
      }
    }

    tbody td {
      border-bottom: 1px solid var(--border-main, #ededed);
      padding: 8px;
    }
  }
`

const tempData = [
  { email: 'kdsknflsdflksdfkldsf' },
  { email: 'kdsknflsdflksdfkldsf' },
  { email: 'kdsknflsdflksdfkldsf' },
  { email: 'kdsknflsdflksdfkldsf' },
  { email: 'kdsknflsdflksdfkldsf' },
  { email: 'kdsknflsdflksdfkldsf' },
  { email: 'kdsknflsdflksdfkldsf' },
  { email: 'kdsknflsdflksdfkldsf' },
  { email: 'kdsknflsdflksdfkldsf' },
  { email: 'kdsknflsdflksdfkldsf' },
  { email: 'kdsknflsdflksdfkldsf' },
]

const SettingTable = () => {
  let [filter, setFilter] = useState({
    sort: '_id',
    perPage: 13,
    search: '',
    direction: '_id',
    // filter: {_id: 1}
  })

  return (
    <TableStyle hasdata='true'>
      <Table
        Head={SettingsTableHead}
        Body={SettingsTableBody}
        EmptyItems={Empty}
        NothingFound={NothingFound}
        apiSearchFileds={['name']}
        onFilter={(it: any, filter: any) => {
          if (filter._id) {
            return it._id == filter._id
          }
          return true
        }}
        onSearch={(it: any, reg: any) => {
          return reg.test(it.name)
        }}
        onChangeFilter={(v: any) => {
          setFilter(v)
        }}
        filter={filter}
        items={[...tempData, ...tempData, ...tempData, ...tempData]}
      />
    </TableStyle>
  )
}

export default SettingTable
